// import React from "react";
// import "../../Styles/roofAnimation.css";

// const RoofOutline = () => {
//   return (
//     <svg
//       className="roof-outline"
//       width="120"
//       height="70"
//       viewBox="0 0 120 70"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       {/* Left vertical line */}
//       <path
//         className="line left"
//         d="M10 60 V20"
//         stroke="#FFA500"
//         strokeWidth="2"
//       />
//       {/* Right vertical line */}
//       <path
//         className="line right"
//         d="M110 60 V20"
//         stroke="#FFA500"
//         strokeWidth="2"
//       />
//       {/* Top peak line */}
//       <path
//         className="line top"
//         d="M10 20 L60 5 L110 20"
//         stroke="#FFA500"
//         strokeWidth="2"
//         fill="transparent"
//       />
//     </svg>
//   );
// };

// export default RoofOutline;

// import React from "react";
// import "../../Styles/roofAnimation.css";

// const RoofOutline = () => {
//   return (
//     <div className="roof-wrapper">
//       <svg
//         className="roof-outline"
//         viewBox="0 0 200 150"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           className="roof-path"
//           d="M20 130 L20 80 L100 20 L180 80 L180 130"
//           stroke="#FFA500"
//           strokeWidth="3"
//           fill="none"
//         />

//       </svg>
//     </div>
//   );
// };

// export default RoofOutline;

import React from "react";
import "../../Styles/roofAnimation.css";

const RoofOutline = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="roof-wrapper">
      <svg
        className="roof-outline first-card"
        viewBox="0 0 200 250"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Top hex outline */}
        <path
          className="roof-path top"
          d="M20 130 L20 80 L100 20 L180 80 L180 130"
          stroke="#FFA500"
          strokeWidth="3"
          fill="none"
        />

        {/* Bottom hex outline (downward shape) */}
      </svg>
      <svg
        className="roof-outline second-card"
        viewBox="0 0 200 250"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="roof-path bottom"
          d="M20 80 L20 130 L100 200 L180 130 L180 80"
          stroke="#003366"
          strokeWidth="3"
          fill="none"
        />
      </svg>
      <svg
        className="roof-outline third-card"
        viewBox="0 0 200 250"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Top hex outline */}
        <path
          className="roof-path top"
          d="M20 130 L20 80 L100 20 L180 80 L180 130"
          stroke="#C20607"
          strokeWidth="3"
          fill="none"
        />

        {/* Bottom hex outline (downward shape) */}
      </svg>
    </div>
  );
};

export default RoofOutline;
